import { Routes } from '@angular/router';
import { RegistrationAlreadyRegisteredPage } from './pages/registration-already-registered-page/registration-already-registered-page';
import { RegistrationConfirmationPage } from './pages/registration-confirmation-page/registration-confirmation-page';
import { RegistrationGroupPage } from './pages/registration-group-page/registration-group-page';
import { RegistrationInformationPage } from './pages/registration-information-page/registration-information-page';
import { RegistrationLandingPage } from './pages/registration-landing-page/registration-landing-page';
import { RegistrationMatchingPage } from './pages/registration-matching-page/registration-matching-page';
import { RegistrationQuestionPage } from './pages/registration-question-page/registration-question-page';

export enum AppRoutePaths {
	LandingPage = '/',
	RegistrationInformation = '/register/information',
	RegistrationQuestions = '/register/questions',
	RegistrationMatching = '/register/matching',
	RegistrationGroup = '/register/group',
	RegistrationAlreadyRegistered = '/register/already-registered',
	RegistrationConfirmation = '/register/confirmation'
}

export const routes: Routes = [
	{
		path: AppRoutePaths.LandingPage.substring(1),
		component: RegistrationLandingPage
	},
	{
		path: AppRoutePaths.RegistrationInformation.substring(1),
		component: RegistrationInformationPage
	},
	{
		path: AppRoutePaths.RegistrationQuestions.substring(1),
		component: RegistrationQuestionPage
	},
	{
		path: AppRoutePaths.RegistrationMatching.substring(1),
		component: RegistrationMatchingPage
	},
	{
		path: AppRoutePaths.RegistrationGroup.substring(1),
		component: RegistrationGroupPage
	},
	{
		path: AppRoutePaths.RegistrationConfirmation.substring(1),
		component: RegistrationConfirmationPage
	},
	{
		path: AppRoutePaths.RegistrationAlreadyRegistered.substring(1),
		component: RegistrationAlreadyRegisteredPage
	}
];
